<template>
  <div
    class="index-banner container"
    v-if="adbannerlist"
    @click="golink(adbannerlist.linkUrl, adbannerlist.actiontype)"
  >
    <img :src="adbannerlist.pc_imgUrl" class="hidden-xs" mode="widthFix" />
    <img
      :src="adbannerlist.imgUrl"
      class="hidden-lg hidden-md hidden-sm"
      mode="widthFix"
    />
  </div>
</template>

<script>
export default {
  props: ["adbannerlist"],
  methods: {
    golink(url, actiontype) {
      //   this.$router.push({
      //     path: url
      //   });
      if (actiontype == "page") {
        window.open(url, "_self");
      } else {
        window.open(url, "_blank");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.index-banner {
  height: auto;
  margin: auto;
  @media (max-width: 991px) {
    height: auto;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/indexbanner.vue